/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout/Layout";
import OwlCarousel from "react-owl-carousel";
import { Helmet } from "react-helmet";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { scrollToSection, scrollToTop } from "../../utility/CommonFunctions";
import { useDispatch } from "react-redux";
import { setActiveId } from "../../store/actions/UserActions";
// import ContactUs from "./ContactUs";
import { RoutesLink } from "../../ApiHelper/RoutesLink";
import { callApi } from "../../ApiHelper/ApiHelper";
import { apiUrl } from "../../ApiHelper/ApiUrl";
import BoxLoader from "../../components/Loaders/BoxLoader";
import { Spinner } from "reactstrap";
import FaqList from "./FaqList";
import { DynamicMetaTags } from "../../components/comman/DynamicMetaTags";

export default function LandingPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const options = {
    loop: true,
    margin: 10,
    nav: false,
    dots: true,
    autoplay: true,
    smartSpeed: 2500,
    center: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 3,
      },
      1000: {
        items: 3,
      },
    },
  };

  const screen_slider = [
    {
      id: 1,
      imgUrl: `${process.env.PUBLIC_URL}/assets/images/screen-1.png`,
    },
    {
      id: 2,
      imgUrl: `${process.env.PUBLIC_URL}/assets/images/screen-2.png`,
    },
    {
      id: 3,
      imgUrl: `${process.env.PUBLIC_URL}/assets/images/screen-3.png`,
    },
    {
      id: 4,
      imgUrl: `${process.env.PUBLIC_URL}/assets/images/screen-4.png`,
    },
    {
      id: 5,
      imgUrl: `${process.env.PUBLIC_URL}/assets/images/screen-5.png`,
    },
    {
      id: 6,
      imgUrl: `${process.env.PUBLIC_URL}/assets/images/screen-6.png`,
    },
    {
      id: 7,
      imgUrl: `${process.env.PUBLIC_URL}/assets/images/screen-7.png`,
    },
    {
      id: 8,
      imgUrl: `${process.env.PUBLIC_URL}/assets/images/screen-8.png`,
    },
    {
      id: 9,
      imgUrl: `${process.env.PUBLIC_URL}/assets/images/screen-9.png`,
    },
    {
      id: 10,
      imgUrl: `${process.env.PUBLIC_URL}/assets/images/screen-10.png`,
    },
    {
      id: 11,
      imgUrl: `${process.env.PUBLIC_URL}/assets/images/screen-11.png`,
    },
    {
      id: 12,
      imgUrl: `${process.env.PUBLIC_URL}/assets/images/screen-12.png`,
    },
  ];

  useEffect(() => {
    if (location?.state?.id) {
      scrollToSection(location?.state?.id);
      window.history.replaceState({}, "");
    } else {
      dispatch(setActiveId(""));
      scrollToTop();
    }
  }, []);

  return (
    <Layout>
      <div>
        {/* Banner-Section-Start */}
        <section className="banner_section">
          {/* container start */}
          <div className="container">
            {/* vertical animation line */}
            <div className="anim_line">
              <span>
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
                  alt="anim_line"
                />
              </span>
              <span>
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
                  alt="anim_line"
                />
              </span>
              <span>
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
                  alt="anim_line"
                />
              </span>
              <span>
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
                  alt="anim_line"
                />
              </span>
              <span>
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
                  alt="anim_line"
                />
              </span>
              <span>
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
                  alt="anim_line"
                />
              </span>
              <span>
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
                  alt="anim_line"
                />
              </span>
              <span>
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
                  alt="anim_line"
                />
              </span>
              <span>
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
                  alt="anim_line"
                />
              </span>
            </div>
            {/* row start */}
            <div className="row">
              <div
                className="col-lg-6 col-md-12 mb-5 mb-lg-0"
                data-aos="fade-right"
                data-aos-duration={1500}
              >
                {/* banner text */}
                <div className="banner_text">
                  {/* h1 */}
                  {/* h1 */}
                  <h1>
                    Manage All Your{" "}
                    <span>Transport Documents and Accounts with MyBilty</span>
                  </h1>
                  {/* p */}
                  <p>
                    MyBilty brings all transport document and account management
                    needs into one easy-to-use platform, designed to simplify
                    and optimise your transport business. In managing documents,
                    accounts, and ledgers, along with quotation management,
                    tracking deliveries, coordinating tasks, and checking
                    expenses, MyBilty ensures efficiency and control throughout
                    every step of your operation.
                  </p>
                </div>
                {/* app buttons */}
                <ul className="app_btn mb-4">
                  <li>
                    <a
                      href={
                        "https://play.google.com/store/apps/details?id=com.my_bilty&pli=1"
                      }
                      target="_blank"
                    >
                      <img
                        className="blue_img"
                        src={`${process.env.PUBLIC_URL}/assets/images/google_play.png`}
                        alt="image"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href={
                        "https://apps.apple.com/in/app/mybilty/id6756602493"
                      }
                    >
                      <img
                        className="blue_img"
                        src={`${process.env.PUBLIC_URL}/assets/images/app_store.png`}
                        alt="image"
                      />
                    </a>
                  </li>
                </ul>
                <ul className="app_btn">
                  <li>
                    <a
                      href={"https://webapp.mybilty.com/login"}
                      target="_blank"
                    >
                      <button className="btn btn-primary">
                        Get Free Trial Now{" "}
                      </button>
                    </a>
                  </li>
                  <li>
                    <button
                      className="btn white_btn"
                      onClick={() => {
                        dispatch(setActiveId(""));
                        navigate(RoutesLink.ContactUs);
                      }}
                    >
                      Schedule a demo
                    </button>
                  </li>
                </ul>
              </div>
              {/* banner slides start */}
              <div
                className="col-lg-6 col-md-12"
                data-aos="fade-in"
                data-aos-duration="1500"
              >
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/desktop_frame.png`}
                  alt="image"
                />
              </div>
              {/* banner slides end */}
            </div>
            {/* row end */}
          </div>
          {/* container end */}
        </section>
        {/* Banner-Section-end */}
        {/* Features-Section-Start */}
        <section className="row_am features_section">
          {/* container start */}
          <div className="container">
            <div
              className="section_title"
              data-aos="fade-up"
              data-aos-duration={1500}
              data-aos-delay={100}
            >
              {/* h2 */}
              <h2>
                Features That Make{" "}
                <span>MyBilty the Go-To Solution for Every Transporter </span>
              </h2>
              {/* p */}
              <p>
                MyBilty streamlines transport operations by keeping all your
                documents and accounts in one place. From online Bilty and
                loading slips to delivery slips and quotations, you can manage
                everything effortlessly.{" "}
              </p>
            </div>
            <div id="features"></div>
            <div className="features-inner">
              <div className="feature_detail">
                {/* feature box left */}
                {/* feature image */}
                <div
                  className="feature_img sdal-1"
                  data-aos="fade-up"
                  data-aos-duration={1500}
                  data-aos-delay={100}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/features_frame.png`}
                    alt="image"
                  />
                </div>
                <div className="left_data feature_box sdal-2">
                  <h3>
                    Document <span>Management</span>
                  </h3>
                  {/* feature box */}
                  <div
                    className="data_block"
                    data-aos="fade-right"
                    data-aos-duration={1500}
                  >
                    <div className="text">
                      <h4>Online Bilty Creation &amp; Management</h4>
                      <p>
                        Create and track Bilty with ease, including essential
                        information such as consignor, consignee, goods
                        description, vehicle information, and trip details.
                      </p>
                    </div>
                  </div>
                  {/* feature box */}
                  <div
                    className="data_block"
                    data-aos="fade-right"
                    data-aos-duration={1500}
                  >
                    <div className="text">
                      <h4>Loading Slip Management</h4>
                      <p>
                        Organise the loading of goods without hassle by directly
                        integrating with accounts and receipts, reducing errors.
                      </p>
                    </div>
                  </div>
                  {/* feature box */}
                  <div
                    className="data_block"
                    data-aos="fade-left"
                    data-aos-duration={1500}
                  >
                    <div className="text">
                      <h4>Delivery Slip Management</h4>
                      <p>
                        Confirm, track, and archive delivery details of goods
                        with structured delivery slips for increased accuracy
                        and transparency.
                      </p>
                    </div>
                  </div>
                  {/* feature box */}
                  <div
                    className="data_block"
                    data-aos="fade-left"
                    data-aos-duration={1500}
                  >
                    <div className="text">
                      <h4>Quotation Management</h4>
                      <p>
                        Get professional quotations, monitor their status, and
                        easily follow up to get more business.{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* section2 */}
              <div className="feature_detail">
                <div className="left_data feature_box sdal-3">
                  <h3>
                    Accounts <span>Management </span>
                  </h3>
                  {/* feature box */}
                  <div
                    className="data_block"
                    data-aos="fade-right"
                    data-aos-duration={1500}
                  >
                    <div className="text">
                      <h4>Account Ledger</h4>
                      <p>
                        Track all your detailed financial records linked to
                        transport activities, like loading slips, receipts, and
                        invoices, for maximum transparency and accuracy.
                      </p>
                    </div>
                  </div>
                  {/* feature box */}
                  <div
                    className="data_block"
                    data-aos="fade-right"
                    data-aos-duration={1500}
                  >
                    <div className="text">
                      <h4>Profit/Loss Statement</h4>
                      <p>
                        Prepare summarised profit/loss statements along with
                        party/vehicle-wise reports to have better insight into
                        financials and take strategic decisions.
                      </p>
                    </div>
                  </div>
                  {/* feature box */}
                  <div
                    className="data_block"
                    data-aos="fade-left"
                    data-aos-duration={1500}
                  >
                    <div className="text">
                      <h4>Expense Tracking</h4>
                      <p>
                        Log, categorise, and analyse direct and indirect costs
                        with clear visibility of the costs of running your
                        operation.
                      </p>
                    </div>
                  </div>
                  {/* feature box */}
                  <div
                    className="data_block"
                    data-aos="fade-left"
                    data-aos-duration={1500}
                  >
                    <div className="text">
                      <h4>Cash &amp; Bank Book</h4>
                      <p>
                        Get an easy-to-use cash and bank book that makes
                        tracking transactions and balances instantly easy.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="feature_img sdal-4"
                  data-aos="fade-up"
                  data-aos-duration={1500}
                  data-aos-delay={100}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/feature_frame1.png`}
                    alt="image"
                  />
                </div>
              </div>
              {/* section3 */}
              <div className="feature_detail">
                <div
                  className="feature_img sdal-5"
                  data-aos="fade-up"
                  data-aos-duration={1500}
                  data-aos-delay={100}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/features_frame2.png`}
                    alt="image"
                  />
                </div>
                <div className="left_data feature_box sdal-6">
                  <h3>
                    Driver <span>App</span>
                  </h3>
                  {/* feature box */}
                  <div
                    className="data_block"
                    data-aos="fade-right"
                    data-aos-duration={1500}
                  >
                    <div className="text">
                      <h4>Task Management</h4>
                      <p>
                        Assign and track driver-specific tasks for loading,
                        delivery, and all operations for accountability.
                      </p>
                    </div>
                  </div>
                  {/* feature box */}
                  <div
                    className="data_block"
                    data-aos="fade-right"
                    data-aos-duration={1500}
                  >
                    <div className="text">
                      <h4>GPS Tracking</h4>
                      <p>
                        Real-time navigation and trip monitoring for drivers;
                        improve route efficiency and avoid delays.
                      </p>
                    </div>
                  </div>
                  {/* feature box */}
                  <div
                    className="data_block"
                    data-aos="fade-left"
                    data-aos-duration={1500}
                  >
                    <div className="text">
                      <h4>Upload Delivery Documents</h4>
                      <p>
                        Allow drivers to upload proof of delivery (POD) and
                        report issues immediately from the app.
                      </p>
                    </div>
                  </div>
                  {/* feature box */}
                  <div
                    className="data_block"
                    data-aos="fade-left"
                    data-aos-duration={1500}
                  >
                    <div className="text">
                      <h4>Real-Time Updates</h4>
                      <p>
                        Notify drivers in real time about tasks, schedules, and
                        changes to avoid miscommunication and improve
                        coordination.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* section4 */}
              <div className="feature_detail">
                <div className="left_data feature_box sdal-7">
                  <h3>
                    Additional <span>Features</span>
                  </h3>
                  {/* feature box */}
                  <div
                    className="data_block"
                    data-aos="fade-right"
                    data-aos-duration={1500}
                  >
                    <div className="text">
                      <h4>Subscription Management</h4>
                      <p>
                        Access flexible subscription plans according to your
                        requirements, with trials and automatic renewal
                        reminders to avoid loss of service.
                      </p>
                    </div>
                  </div>
                  {/* feature box */}
                  <div
                    className="data_block"
                    data-aos="fade-right"
                    data-aos-duration={1500}
                  >
                    <div className="text">
                      <h4>Directory</h4>
                      <p>
                        The Directory is a centralized database that stores all
                        logistics contacts—including consignors, consignees,
                        drivers, transporters, and vehicles—to simplify bilty
                        and booking operations.
                      </p>
                    </div>
                  </div>
                  {/* feature box */}
                  <div
                    className="data_block"
                    data-aos="fade-left"
                    data-aos-duration={1500}
                  >
                    <div className="text">
                      <h4>View Market</h4>
                      <p>
                        The View Market is a real-time digital load board that
                        helps transporters and fleet owners quickly find and
                        book loads without phone calls or market visits.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="feature_img sdal-8"
                  data-aos="fade-up"
                  data-aos-duration={1500}
                  data-aos-delay={100}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/features_frame3.png`}
                    alt="image"
                  />
                </div>
              </div>
            </div>
          </div>
          {/* container end */}
        </section>
        {/* Features-Section-end */}
        {/* How-It-Workes-Section-Start */}
        <section className="row_am how_it_works" id="how_it_work">
          {/* container start */}
          <div className="container">
            <div className="how_it_inner">
              <div
                className="section_title"
                data-aos="fade-up"
                data-aos-duration={1500}
                data-aos-delay={300}
              >
                {/* h2 */}
                <h2>
                  Create Your MyBilty Account in <span>3 Easy Steps</span>
                </h2>
                {/* p */}
                <p>
                  Easily set up your MyBilty transporter account by following
                  these steps.
                </p>
              </div>
              <div className="step_block">
                {/* UL */}
                <ul>
                  {/* step */}
                  <li>
                    <div
                      className="step_text"
                      data-aos="fade-right"
                      data-aos-duration={1500}
                    >
                      <h4>Download app</h4>
                      <div className="app_icon">
                        <a href="#">
                          <i className="icofont-brand-android-robot" />
                        </a>
                        <a href="#">
                          <i className="icofont-brand-apple" />
                        </a>
                        <a href="#">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={20}
                            height={20}
                            fill="currentColor"
                            className="bi bi-globe"
                            viewBox="0 0 16 16"
                          >
                            <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.5-6.923c-.67.204-1.335.82-1.887 1.855A8 8 0 0 0 5.145 4H7.5zM4.09 4a9.3 9.3 0 0 1 .64-1.539 7 7 0 0 1 .597-.933A7.03 7.03 0 0 0 2.255 4zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a7 7 0 0 0-.656 2.5zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5zM8.5 5v2.5h2.99a12.5 12.5 0 0 0-.337-2.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5zM5.145 12q.208.58.468 1.068c.552 1.035 1.218 1.65 1.887 1.855V12zm.182 2.472a7 7 0 0 1-.597-.933A9.3 9.3 0 0 1 4.09 12H2.255a7 7 0 0 0 3.072 2.472M3.82 11a13.7 13.7 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5zm6.853 3.472A7 7 0 0 0 13.745 12H11.91a9.3 9.3 0 0 1-.64 1.539 7 7 0 0 1-.597.933M8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855q.26-.487.468-1.068zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.7 13.7 0 0 1-.312 2.5m2.802-3.5a7 7 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7 7 0 0 0-3.072-2.472c.218.284.418.598.597.933M10.855 4a8 8 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4z" />
                          </svg>
                        </a>
                      </div>
                      <p>
                        Download the MyBilty app either from the Google Play
                        Store or App Store, or you can directly sign up through
                        our website.
                      </p>
                    </div>
                    <div className="step_number">
                      <h3>01</h3>
                    </div>
                    <div
                      className="step_img"
                      data-aos="fade-left"
                      data-aos-duration={1500}
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/download_app.png`}
                        alt="image"
                      />
                    </div>
                  </li>
                  {/* step */}
                  <li>
                    <div
                      className="step_text"
                      data-aos="fade-left"
                      data-aos-duration={1500}
                    >
                      <h4>Create Your Account</h4>
                      <span> 50-day free trial</span>
                      <p>
                        Fill in the basic details of your business, like the
                        transporter's name, email, phone number, state, city,
                        zip code, etc., and verify your account with OTP.
                      </p>
                    </div>
                    <div className="step_number">
                      <h3>02</h3>
                    </div>
                    <div
                      className="step_img"
                      data-aos="fade-right"
                      data-aos-duration={1500}
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/create_account.png`}
                        alt="image"
                      />
                    </div>
                  </li>
                  {/* step */}
                  <li>
                    <div
                      className="step_text"
                      data-aos="fade-right"
                      data-aos-duration={1500}
                    >
                      <h4>Your MyBilty Account is Ready </h4>
                      <span>
                        Have any questions check our{" "}
                        <a href="#faqsection">FAQs</a>
                      </span>
                      <p>
                        After that, your account will be successfully created.
                        You can manage all your transport documents and accounts
                        in one place seamlessly!
                      </p>
                    </div>
                    <div className="step_number">
                      <h3>03</h3>
                    </div>
                    <div
                      className="step_img"
                      data-aos="fade-left"
                      data-aos-duration={1500}
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/enjoy_app.png`}
                        alt="image"
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* container end */}
        </section>
        {/* How-It-Workes-Section-end */}
        {/* Pricing-Section */}
        <section className="row_am pricing_section " id="pricing">
          {/* container start */}
          <div className="container">
            <div
              className="section_title"
              data-aos="fade-up"
              data-aos-duration={1500}
              data-aos-delay={300}
            >
              {/* h2 */}
              <h2 className="mt-5">Pricing Plans</h2>
              {/* p */}
            </div>
            {/* toggle button */}
            <div
              className="toggle_block d-none"
              data-aos="fade-up"
              data-aos-duration={1500}
            >
              <span className="month active">Monthly</span>
              <div className="tog_block">
                <span className="tog_btn" />
              </div>
              <span className="years">Yearly</span>
              <span className="offer">50% off</span>
            </div>
            {/* pricing box  monthly start */}
            <div
              className="pricing_pannel monthly_plan active"
              data-aos="fade-up"
              data-aos-duration={1500}
            >
              {/* row start */}
              <div className="row">
                {/* pricing box 1 */}
                <div className="col-md-4">
                  <div className="pricing_block">
                    <div className="pkg_name">
                      <h3>Employee Plan</h3>
                      <span>For the Transportation</span>
                    </div>
                    <span className="price">₹599</span>
                    <ul className="benifits">
                      <li>
                        <p>For 365 Days</p>
                      </li>
                      <li>
                        <p>Create Employee</p>
                      </li>
                      <li>
                        <p>Edit & Delete Employee</p>
                      </li>
                      <li>
                        <p>Temporarily Inactive Employee Option</p>
                      </li>
                      <li>
                        <p>24/7 Customer support</p>
                      </li>
                    </ul>
                    <Link
                      to={RoutesLink.ContactUs}
                      className="btn white_btn"
                      onClick={() => dispatch(setActiveId("contact-us"))}
                    >
                      Contact us
                    </Link>
                  </div>
                </div>

                {/* pricing box 2 */}
                <div className="col-md-4">
                  <div className="pricing_block highlited_block">
                    <div className="pkg_name">
                      <h3>Annual Plan</h3>
                      <span>Unlock all the power of this tool.</span>
                    </div>
                    <span className="price">₹999</span>
                    <ul className="benifits">
                      <li>
                        <p>For 365 Days</p>
                      </li>
                      <li>
                        <p>Bilty</p>
                      </li>
                      <li>
                        <p>Quotation & Loading Slip</p>
                      </li>
                      <li>
                        <p>Invoice & Delivery Memo</p>
                      </li>
                      <li>
                        <p>Truck Hire Challan</p>
                      </li>
                      <li>
                        <p>Accounts & Reports</p>
                      </li>
                    </ul>
                    <Link
                      to={RoutesLink.ContactUs}
                      className="btn white_btn"
                      onClick={() => dispatch(setActiveId("contact-us"))}
                    >
                      Contact us
                    </Link>
                  </div>
                </div>

                {/* pricing box 3 */}
                <div className="col-md-4">
                  <div className="pricing_block">
                    <div className="pkg_name">
                      <h3>Branch Plan</h3>
                      <span>For the Transportation</span>
                    </div>
                    <span className="price">₹699</span>
                    <ul className="benifits">
                      <li>
                        <p>For 365 Days</p>
                      </li>
                      <li>
                        <p>Create Branch</p>
                      </li>
                      <li>
                        <p>Edit & Delete Branch</p>
                      </li>
                      <li>
                        <p>Temporarily Inactive Branch Option</p>
                      </li>
                      <li>
                        <p>24/7 Customer support</p>
                      </li>
                    </ul>
                    <Link
                      to={RoutesLink.ContactUs}
                      className="btn white_btn"
                      onClick={() => dispatch(setActiveId("contact-us"))}
                    >
                      Contact us
                    </Link>
                  </div>
                </div>
              </div>
              {/* row end */}
            </div>
            {/* pricing box monthly end */}
            {/* pricing box yearly start */}
            <div className="pricing_pannel yearly_plan">
              <div className="row">
                {/* pricing box 1 */}
                <div className="col-md-4">
                  <div className="pricing_block">
                    <div className="pkg_name">
                      <h3>Standard</h3>
                      <span>For the basics</span>
                    </div>
                    <span className="price">$150</span>
                    <ul className="benifits">
                      <li>
                        <p>Up to 10 Website</p>
                      </li>
                      <li>
                        <p>100 GB disk space</p>
                      </li>
                      <li>
                        <p>25 Customize sub pages</p>
                      </li>
                      <li>
                        <p>4 Domains access</p>
                      </li>
                      <li>
                        <p>Support on request</p>
                      </li>
                    </ul>
                    <a href={() => false} className="btn white_btn">
                      BUY NOW
                    </a>
                  </div>
                </div>
                {/* pricing box 2 */}
                <div className="col-md-4">
                  <div className="pricing_block highlited_block">
                    <div className="pkg_name">
                      <h3>Unlimited</h3>
                      <span>For the professionals</span>
                    </div>
                    <span className="price">$999</span>
                    <ul className="benifits">
                      <li>
                        <p>Unlimited Website</p>
                      </li>
                      <li>
                        <p>400 GB disk space</p>
                      </li>
                      <li>
                        <p>40 Customize sub pages</p>
                      </li>
                      <li>
                        <p>20 Domains access</p>
                      </li>
                      <li>
                        <p>24/7 Customer support</p>
                      </li>
                    </ul>
                    <a href={() => false} className="btn white_btn">
                      BUY NOW
                    </a>
                  </div>
                </div>
                {/* pricing box 3 */}
                <div className="col-md-4">
                  <div className="pricing_block">
                    <div className="pkg_name">
                      <h3>Premium</h3>
                      <span>For small team</span>
                    </div>
                    <span className="price">$550</span>
                    <ul className="benifits">
                      <li>
                        <p>Up to 20 Website</p>
                      </li>
                      <li>
                        <p>200 GB disk space</p>
                      </li>
                      <li>
                        <p>25 Customize sub pages</p>
                      </li>
                      <li>
                        <p>8 Domains access</p>
                      </li>
                      <li>
                        <p>24/7 Customer support</p>
                      </li>
                    </ul>
                    <a href={() => false} className="btn white_btn">
                      BUY NOW
                    </a>
                  </div>
                </div>
              </div>
            </div>
            {/* pricing box yearly end */}
            <p
              className="contact_text"
              data-aos="fade-up"
              data-aos-duration={1500}
            >
              Not sure what to choose ?{" "}
              <Link
                to={RoutesLink.ContactUs}
                onClick={() => dispatch(setActiveId(""))}
              >
                contact us
              </Link>{" "}
              for custom packages
            </p>
          </div>
          {/* container start end */}
        </section>
        {/* Pricing-Section end */}
        {/* Beautifull-interface-Section start */}
        <section className="row_am interface_section">
          {/* container start */}
          <div className="container-fluid">
            <div
              className="section_title"
              data-aos="fade-up"
              data-aos-duration={1500}
              data-aos-delay={300}
            >
              {/* h2 */}
              <div className="container">
                <h2>
                  MyBilty <span>Interface Preview </span>
                </h2>
                {/* p */}
                <p>
                  Explore MyBilty’s intuitive interface, designed to simplify
                  transport management. Effortlessly track and
                  <br />
                  manage all your transport documents and accounts in one
                  easy-to-use platform.
                </p>
              </div>
            </div>
            {/* screen slider start */}
            <div className="screen_slider">
              <OwlCarousel
                {...options}
                id="screen_slider"
                className="owl-carousel owl-theme"
              >
                {screen_slider &&
                  screen_slider?.length > 0 &&
                  screen_slider?.map((items) => {
                    return (
                      <div className="item" key={items?.id}>
                        <div className="screen_frame_img">
                          <img src={items?.imgUrl} alt="image" />
                        </div>
                      </div>
                    );
                  })}
              </OwlCarousel>
            </div>
            {/* screen slider end */}
          </div>
          {/* container end */}
        </section>
        {/* Beautifull-interface-Section end */}
        {/* Download-Free-App-section-Start  */}
        <section
          className="row_am free_app_section"
          id="getstarted"
          data-aos="fade-in"
          data-aos-duration={1500}
          data-aos-delay={100}
        >
          {/* container start */}
          <div className="container">
            <div className="free_app_inner">
              {/* vertical line animation */}
              <div className="anim_line dark_bg">
                <span>
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
                    alt="anim_line"
                  />
                </span>
                <span>
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
                    alt="anim_line"
                  />
                </span>
                <span>
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
                    alt="anim_line"
                  />
                </span>
                <span>
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
                    alt="anim_line"
                  />
                </span>
                <span>
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
                    alt="anim_line"
                  />
                </span>
                <span>
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
                    alt="anim_line"
                  />
                </span>
                <span>
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
                    alt="anim_line"
                  />
                </span>
                <span>
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
                    alt="anim_line"
                  />
                </span>
                <span>
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
                    alt="anim_line"
                  />
                </span>
              </div>
              {/* row start */}
              <div className="row">
                {/* content */}
                <div className="col-md-6">
                  <div className="free_text">
                    <div className="section_title">
                      <h2>
                        Download MyBilty App From{" "}
                        <span> Google Play Store </span>
                      </h2>
                      <p>
                        Download the MyBilty app from Google Play Store. Start
                        managing your transport documents and accounts
                        seamlessly, anytime, anywhere!
                      </p>
                    </div>
                    <ul className="app_btn my-4">
                      <li>
                        <a
                          href={
                            "https://play.google.com/store/apps/details?id=com.my_bilty&pli=1"
                          }
                          target="_blank"
                        >
                          <img
                            className="blue_img"
                            src={`${process.env.PUBLIC_URL}/assets/images/google_play.png`}
                            alt="image"
                          />
                        </a>
                      </li>
                      <li>
                        <a
                          href={
                            "https://apps.apple.com/in/app/mybilty/id6756602493"
                          }
                        >
                          <img
                            className="blue_img"
                            src={`${process.env.PUBLIC_URL}/assets/images/app_store.png`}
                            alt="image"
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* images */}
                <div className="col-md-6">
                  <div className="free_img">
                    {/* <img src={`${process.env.PUBLIC_URL}/assets/images/download-screen01.png`} alt="image" /> */}
                    <img
                      className="mobile_mockup"
                      src={`${process.env.PUBLIC_URL}/assets/images/download-screen02.png`}
                      alt="image"
                    />
                  </div>
                </div>
              </div>
              {/* row end */}
            </div>
          </div>
          {/* container end */}
        </section>
        {/* Download-Free-App-section-end  */}
        {/* <ContactUs /> */}

        {/* FAQ-Section start */}
        <section className="row_am faq_section" id="faqsection">
          {/* container start */}
          <div className="container">
            <div className="section_title">
              {/* h2 */}
              <h2>
                {" "}
                Frequently <span>Asked Questions</span>
              </h2>
              {/* p */}
            </div>
            {/* faq data */}

            {/* faq data */}
            <FaqList />
            {/* {!isLoading && state?.pagination?.totalPages > state?.pagination?.currentPage && <div className="mt-5 text-center">
                            <a href={() => false} onClick={handleNextPage} style={{ borderRadius: '30px', cursor: "pointer" }} className="text-white text-center d-inline-block bg-primary px-4 py-2" >
                                See More
                            </a>
                        </div>} */}
            {/* {state?.pagination?.totalPages > 1 && <div className="mt-5 text-center" >
                            <Link style={{ borderRadius: '30px' }} className="text-white text-center d-inline-block bg-primary px-4 py-2" to={RoutesLink?.faq} onClick={() => {
                                dispatch(setActiveId(''));
                            }}>
                                See More
                            </Link>
                        </div>} */}
          </div>
        </section>
        {/* FAQ-Section end */}
      </div>
    </Layout>
  );
}
